import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentApiKey on ApiKey {
    id
    name
    enabled
    createdAt
    expiresAt
    lastUsedAt
  }
`

/**
 * Converts the ISO strings the API returns back into the epoch millis the
 * entity uses.
 *
 * __NOTE:__ takes `unknown` because codegen types `AWSDateTime` as `any` —
 * narrowing here keeps that `any` from leaking into the entity
 */
function toMillis(value: unknown): number | undefined {
  if (!TypeChecker.isString(value)) {
    return undefined
  }

  const millis = new Date(value).getTime()
  return Number.isNaN(millis) ? undefined : millis
}

export const TRANSFORMER = graphql.transformers.OUT.custom<
  graphql.schema.FragmentApiKeyFragment,
  ents.core.admin.ApiKey
>(apiKey => ({
  createdAt: toMillis(apiKey.createdAt) ?? 0,
  enabled: apiKey.enabled,
  expiresAt: toMillis(apiKey.expiresAt),
  id: apiKey.id,
  lastUsedAt: toMillis(apiKey.lastUsedAt),
  name: apiKey.name ?? undefined,
}))
